'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('jquery');

var formValidation = {

  /**
   * Resets field error styling as if they were valid. Remove the red color...
   *
   * @param  {Object} $field Field to reset as jQuery Object.
   */
  resetFieldValidation: function resetFieldValidation($field) {

    var fieldName = $field.attr('name'),
        $fieldWrap = $field.closest('.field-wrap'),
        $messagePlaceholder = $fieldWrap.find('small[data-field-error-for="' + fieldName + '"]');

    // Removes error styling.
    $messagePlaceholder.removeClass('error').html('');

    if ($field.is('select')) {
      $field.siblings('span.customSelect').removeClass('error');
    }

    $field.removeClass('error');
  },

  /**
   * Resets form error styling as if it was valid. Remove the red color...
   *
   * @param  {Object} $form Form to reset as jQuery Object.
   */
  resetFormValidation: function resetFormValidation($form) {

    // Resets error fields
    $form.find('.field-wrap').removeClass('field-wrap--has-error');
    var $fieldsToCheck = $form.find('[data-notempty-message], [data-regexp-message]');

    for (var i = 0; i <= $fieldsToCheck.length; i++) {
      this.resetFieldValidation($($fieldsToCheck[i]));
    }
  },

  /**
   * Sets the error class... where it should be.
   * @param  {Object} $field Field being invalid as jQuery Object.
   * @param  {String} messageType message type to be displayed
   */
  setErrorClass: function setErrorClass($field, messageType) {

    var $fieldWrap = $field.closest('.field-wrap'),
        fieldName = $field.attr('name'),
        $messagePlaceholder = $fieldWrap.find('small[data-field-error-for="' + fieldName + '"]');

    $fieldWrap.addClass('field-wrap--has-error');
    $field.addClass('error');
    $messagePlaceholder.addClass('error').html($field.attr('data-' + messageType + '-message'));

    if ($field.is('select')) {
      $fieldWrap.find('span.customSelect').addClass('error');
    }
  },

  /**
   * Checks whether or not a field is empty.
   *
   * @param  {Object} $field Field to check as jQuery Object.
   * @return {Boolean}       True is the field is empty, false otherwise.
   */
  isEmptyField: function isEmptyField($field) {

    // Check the field according to its type.
    if ($field.is('select')) {
      return this.isEmptyDropdown($field);
    } else if ($field.attr('type') === 'checkbox') {
      return this.isEmptyCheckbox($field);
    } else if ($field.attr('type') === 'radio') {
      return this.isEmptyRadiobox($field);
    } else {

      var val = this.getFieldValue($field);

      if (val.length < 1) {

        this.setErrorClass($field, 'notempty');
        return true;
      }

      return false;
    }
  },

  /**
   * Checks whether or not a field is valid.
   *
   * @param  {Object} $field Field to check as jQuery Object.
   * @return {Boolean}       True is the field is unvalid, false otherwise.
   */
  isUnvalidField: function isUnvalidField($field) {

    var regExp = new RegExp($field.attr('data-pattern'));

    // Checks whether or not it is necessary to strip the value from whitespaces.
    if ($field.attr('data-strip-whitespaces')) {
      $field.val(this.getFieldValue($field).replace(/\s/gi, ''));
    }

    // Checks the field against the regular expression. Only check if the field
    // has a value. 'data-notempty-message' should be used for empty
    // validations.
    if ($field.val().length >= 1 && !regExp.test(this.getFieldValue($field))) {

      this.setErrorClass($field, 'regexp');
      return true;
    }

    return false;
  },

  /**
   * Checks if a dropdown is empty.
   *
   * @param  {Object} $field Field to check as jQuery Object.
   * @return {Boolean}       True is the dropdown has non empty selection
   *                         , false otherwise.
   */
  isEmptyDropdown: function isEmptyDropdown($field) {

    var $selectedOption = $field.find('option:selected');

    if ($selectedOption.val() === '') {

      this.setErrorClass($field, 'notempty');
      return true;
    }

    return false;
  },

  /**
   * Checks if a checkbox is empty.
   *
   * @param  {Object} $field Field to check as jQuery Object.
   * @return {Boolean} False if the checkbox is checked, true otherwise.
   */
  isEmptyCheckbox: function isEmptyCheckbox($field) {

    if ($field.is(':checked')) {
      return false;
    }

    this.setErrorClass($field, 'notempty');
    return true;
  },

  /**
   * Checks if a radiobox is empty.
   *
   * @param  {Object} $field Field to check as jQuery Object.
   * @return {Boolean} False if the radio is selected, true otherwise.
   */
  isEmptyRadiobox: function isEmptyRadiobox($field) {

    if ($field.is(':checked')) {
      return false;
    }

    this.setErrorClass($field, 'notempty');
    return true;
  },

  /**
   * Checks if "make a choice" radioboxes in a wrapper are empty.
   *
   * @param  {Object}   $wrapper to check as jQuery Object.
   * @return {Boolean}  False if one of the "make a choice" radio boxes
   *                    is selected, true otherwise.
   */
  isEmptyRadioSelection: function isEmptyRadioSelection($wrapper) {

    var fieldName = void 0;
    var radios = $wrapper.find('input[type="radio"]');

    for (var i = 0; radios.length > i; i++) {

      fieldName = radios[i].name;

      if (radios[i].checked === true) {
        return false;
      }
    }

    // Set error message and highlightning.
    var $messagePlaceholder = $wrapper.find('small[data-field-error-for="' + fieldName + '"]');
    $wrapper.addClass('field-wrap--has-error');
    $messagePlaceholder.addClass('error').html($wrapper.attr('data-notchecked-radio-wrapper'));

    return true;
  },

  /**
   * Validates fields of a form.
   *
   * @param  {Object} $form  The form on which we want to validate fields.
   * @param  {String} filter (Optional) filter as CSS selector to narrow the
   *                         validation to only certain fields.
   *                         (i.e '[name="ext_flightNumber01"],[name="flight_date"]').
   * @return {boolean}       True if valid, false otherwise.
   */
  validateFields: function validateFields($form, filter) {

    var valid = true,
        i = void 0;

    // Reset fields
    this.resetFormValidation($form);

    // Check for required fields
    var $fieldsToCheck = $form.find('[data-notchecked], [data-notempty-message], [data-regexp-message], [data-notchecked-radio-wrapper]');

    if (filter) {
      $fieldsToCheck = $fieldsToCheck.filter(filter);
    }

    for (i = 0; i <= $fieldsToCheck.length; i++) {

      var isKOField = false;
      var $field = $($fieldsToCheck[i]),
          isTTHint = $field.hasClass('tt-hint');

      // We ignore all typeahead generated fields.
      if (!isTTHint) {

        if ($field.attr('data-notempty-message')) {
          isKOField = this.isEmptyField($field);
        }

        if ($field.attr('data-notchecked-radio-wrapper')) {
          isKOField = this.isEmptyRadioSelection($field);
        }

        if (!isKOField && $field.attr('data-pattern')) {
          isKOField = this.isUnvalidField($field);
        }
      }

      valid = valid && isKOField ? false : valid;
    }

    return valid;
  },

  /**
   * Fetches the value of the given field.
   * @param  {Object} $field Field to check as jQuery Object.
   * @return {String}        The value of the given field.
   */
  getFieldValue: function getFieldValue($field) {

    var value = $field.attr('data-ref-attribute') !== undefined ? $field.attr($field.attr('data-ref-attribute')) : undefined;

    value = value || $field.val();

    return value;
  }

};

exports.default = formValidation;